import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PortfolioPhotoGrid from "./PortfolioPhotoGrid";
const PAPER = "#FAF6EF";
const INK = "#1B1812";
const MUTED = "#8A7E70";
export default function PortfolioShowcase({ portfolios, targetRowHeight = 280, gap = 12, }) {
    const [index, setIndex] = useState(0);
    if (!portfolios.length) {
        return null;
    }
    const portfolio = portfolios[index];
    const previous = () => {
        setIndex((current) => (current - 1 + portfolios.length) % portfolios.length);
    };
    const next = () => {
        setIndex((current) => (current + 1) % portfolios.length);
    };
    return (React.createElement(Box, { sx: {
            width: "100%",
            bgcolor: PAPER,
            py: {
                xs: 5,
                md: 8,
            },
        } },
        React.createElement(Box, { sx: {
                width: {
                    xs: "94%",
                    md: "90%",
                    lg: "86%",
                },
                maxWidth: 1500,
                mx: "auto",
                bgcolor: "#fff",
                border: "1px solid rgba(27, 24, 18, 0.08)",
                boxShadow: "0 18px 50px rgba(27, 24, 18, 0.08)",
                p: {
                    xs: 1.5,
                    sm: 2,
                    md: 3,
                },
            } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: {
                        xs: 1,
                        md: 1.5,
                    },
                    pb: {
                        xs: 1.5,
                        md: 2,
                    },
                } },
                React.createElement(Box, null,
                    React.createElement(Typography, { sx: {
                            fontFamily: "'Cormorant Garamond', serif",
                            fontSize: {
                                xs: "1.5rem",
                                md: "2rem",
                            },
                            lineHeight: 1,
                            color: INK,
                        } }, portfolio.name),
                    React.createElement(Typography, { sx: {
                            mt: 0.6,
                            fontFamily: "'Jost', sans-serif",
                            fontSize: "0.65rem",
                            letterSpacing: "0.14em",
                            textTransform: "uppercase",
                            color: MUTED,
                        } },
                        String(index + 1).padStart(2, "0"),
                        " /",
                        " ",
                        String(portfolios.length).padStart(2, "0"))),
                portfolios.length > 1 && (React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                    } },
                    React.createElement(Box, { component: "button", onClick: previous, "aria-label": "Previous portfolio", sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 36,
                            height: 36,
                            border: "none",
                            bgcolor: "transparent",
                            color: INK,
                            cursor: "pointer",
                            opacity: 0.45,
                            transition: "opacity 200ms ease",
                            "&:hover": {
                                opacity: 1,
                            },
                            "&:focus-visible": {
                                outline: "1px solid rgba(27, 24, 18, 0.4)",
                            },
                        } },
                        React.createElement(ChevronLeftIcon, null)),
                    React.createElement(Box, { component: "button", onClick: next, "aria-label": "Next portfolio", sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 36,
                            height: 36,
                            border: "none",
                            bgcolor: "transparent",
                            color: INK,
                            cursor: "pointer",
                            opacity: 0.45,
                            transition: "opacity 200ms ease",
                            "&:hover": {
                                opacity: 1,
                            },
                            "&:focus-visible": {
                                outline: "1px solid rgba(27, 24, 18, 0.4)",
                            },
                        } },
                        React.createElement(ChevronRightIcon, null))))),
            React.createElement(Box, { key: index, sx: {
                    animation: "portfolioFade 500ms ease",
                    "@keyframes portfolioFade": {
                        from: {
                            opacity: 0,
                            transform: "translateY(6px)",
                        },
                        to: {
                            opacity: 1,
                            transform: "translateY(0)",
                        },
                    },
                } },
                React.createElement(PortfolioPhotoGrid, { photos: portfolio.photos, targetRowHeight: targetRowHeight, gap: gap })))));
}
